/**
 * Created by mukund on 1/6/18.
 *
 * AngularJS directive for scheduler
 */

angular.module('mediacloudApp')
    .directive('scheduler', ['$window', '$filter', '$log', '$timeout', 'Tenant', 'SchedulerService', 'CollectionService', 'Principal', function($window, $filter, $log, $timeout, Tenant, SchedulerService, CollectionService, Principal){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/scheduler/scheduler.html',
            scope: {
                parent: '=',
                activeLink: '=',
                allowScheduling: '=',
                hasEvents: '='
            },
            link: function(scope, element, attrs){

                scope.schedulerLoaded = false;

                scope.page = 0;
                scope.totalEvents = 0;
                scope.currentTotalCount = 0;

                // Tenant Info
                Tenant.info().then(function (data) {
                    if(data) {
                        scope.tenantId = data.id;
                        scope.showUserFullName = data.showUserFullName;
                    }

                });

                // username code
                var userInfo = Principal.getUserInfo();
                scope.userName = userInfo.userName;
                scope.userFullName = userInfo.userFullName;

                // Config used by datepicker
                scope.dateTimePicker = SchedulerService.getDateTimePicker();

                // INTEGRATION_PROVIDER feature flag decides Zoom vs Google (no user choice);
                // defaults to zoom whenever the property is missing, unreadable, or unexpected
                scope.integrationProvider = 'zoom';
                SchedulerService.IntegrationProvider.get({}, function(response){
                    if (response.value === 'google') {
                        scope.integrationProvider = 'google';
                    }
                }, function(err){
                    $log.warn('Unable to read INTEGRATION_PROVIDER, defaulting to zoom', err);
                });

                scope.toggleEventForm = function(showEventForm){
                    scope.showEventForm = showEventForm;
                    if(!scope.showEventForm){
                        scope.formType = undefined;
                        $("#cancelConfirmation").modal('hide');
                    }
                };

                scope.resetScheduler = function(){
                    scope.eventsList = {
                        events: [],
                        scheduledEvents: [],
                        eventDates: [],
                        totalEventsFromDate: 0,
                        date: new Date()
                    };
                    scope.toggleEventForm(false);
                };

                var loadScheduler = function(){
                    SchedulerService.getContributors({baseCollectionId: scope.parent.cid})
                        .then(function(response){
                            scope.contributors = response;
                            if(response.length){
                                scope.contributorNames = [];
                                angular.forEach(scope.contributors, function(contributor){
                                    scope.contributorNames.push((scope.showUserFullName && contributor.user.firstName != null && contributor.user.lastName != null) ? contributor.user.firstName + ' ' + contributor.user.lastName : contributor.user.login)
                                });
                            }
                            scope.resetScheduler();
                            scope.schedulerLoaded = true;
                        }).catch(function(err) {
                            scope.error = err;
                            $log.error("An error occurred when trying to fetch contributors");
                        });
                };

                scope.getEvents = function(startDate, totalEvents){
                    $('#listing-section').hide();
                    $('.empty-wrapper').show();
                    scope.showLoadMoreEvents = false;
                    var startDateTime = moment(startDate).hour(0).minute(0).second(0),
                        endDateTime = moment(startDate).add(7, "days").hour(23).minute(59).second(59);
                    SchedulerService.getEvents({
                        startDateTime: startDateTime.format("YYYY-MM-DD HH:mm:ss"),
                        endDateTime: endDateTime.format("YYYY-MM-DD HH:mm:ss"),
                        timeZone: moment.tz.guess(),
                        baseCollectionId: scope.parent.cid,
                        page: 0,
                        size: 500
                    }).then(function(response){
                        scope.totalEvents = totalEvents;
                        if (scope.page == 0) {
                            // make recurring meeting call here
                            SchedulerService.getRecurringEvents({
                                baseCollectionId: scope.parent.cid,
                            }).then(function(response){
                                scope.currentTotalCount += response.result.length;
                                scope.showLoadMoreEvents = totalEvents > scope.currentTotalCount;
                                angular.forEach(response.result, function(event){
                                    event.eventInfo = JSON.parse(event.eventInfo);
                                    event.startTimeFormatted = moment(event.startTime).format("h:mma");
                                    event.endTimeFormatted = moment(event.endTime).format("h:mma");
                                    event.dateFormatted = event.startTimeFormatted + ' - ' + event.endTimeFormatted;
                                    event.date = moment(event.startTime).format("ddd, MMM D, YYYY");
                                    if (event.eventInfo.meetingType && event.eventInfo.meetingType === 3) {
                                        event.startTimeFormatted = '';
                                        event.endTimeFormatted = '';
                                        event.date = '-';
                                        event.dateFormatted = '';
                                    }
                                    event.contributor = (scope.showUserFullName && event.externalUserEntity.user.firstName != null && event.externalUserEntity.user.lastName != null) ? event.externalUserEntity.user.firstName + ' ' + event.externalUserEntity.user.lastName : event.externalUserEntity.user.login;
                                    event.isElapsed = event.eventInfo.meetingType === 3 ? false : moment().isAfter(event.startTime) && !moment().isBetween(event.startTime, event.endTime);
                                    if(scope.eventsList.eventDates.indexOf(event.date) === -1){
                                        scope.eventsList.eventDates.unshift(event.date);
                                    }
                                    var exists = scope.eventsList.events.filter(x => x.eventId == event.eventId).length > 0;
                                    if (!exists)
                                        scope.eventsList.events.push(event);
                                });
                            });
                        }
                        if(response.content.length){
                            var content = response.content;
                            scope.currentTotalCount += response.content.length;
                            scope.showLoadMoreEvents = totalEvents > scope.currentTotalCount;
                            angular.forEach(content, function(event){
                                event.eventInfo = JSON.parse(event.eventInfo);
                                event.startTimeFormatted = moment(event.startTime).format("h:mma");
                                event.endTimeFormatted = moment(event.endTime).format("h:mma");
                                event.dateFormatted = event.startTimeFormatted + ' - ' + event.endTimeFormatted;
                                event.date = moment(event.startTime).format("ddd, MMM D, YYYY");
                                if (event.eventInfo.meetingType && event.eventInfo.meetingType === 3) {
                                    event.startTimeFormatted = '';
                                    event.endTimeFormatted = '';
                                    event.date = '-';
                                    event.dateFormatted = '';
                                }
                                event.contributor = (scope.showUserFullName && event.externalUserEntity.user.firstName != null && event.externalUserEntity.user.lastName != null) ? event.externalUserEntity.user.firstName + ' ' + event.externalUserEntity.user.lastName : event.externalUserEntity.user.login;
                                event.isElapsed = event.eventInfo.meetingType === 3 ? false : moment().isAfter(event.startTime) && !moment().isBetween(event.startTime, event.endTime);
                                if(scope.eventsList.eventDates.indexOf(event.date) === -1){
                                    scope.eventsList.eventDates.push(event.date);
                                }
                                var exists = scope.eventsList.events.filter(x => x.eventId == event.eventId).length > 0;
                                if (!exists) {
                                    scope.eventsList.events.push(event);
                                    scope.eventsList.scheduledEvents.push(event);
                                }
                            });
                        } else {
                            if(totalEvents > scope.currentTotalCount) {
                                scope.getEvents(endDateTime.toDate(), totalEvents);
                            }
                        }
                        $('.empty-wrapper').hide();
                        $('#listing-section').show();
                        scope.fetchGoogleEvents(startDateTime, endDateTime);
                    }).catch(function(err) {
                        scope.error = err;
                        $log.error("An error occurred when trying to fetch events");
                    });
                };

                scope.fetchGoogleEvents = function(startDateTime, endDateTime){
                    SchedulerService.getGoogleEvents({
                        startDateTime: startDateTime.format("YYYY-MM-DD HH:mm:ss"),
                        endDateTime: endDateTime.format("YYYY-MM-DD HH:mm:ss"),
                        timeZone: moment.tz.guess(),
                        baseCollectionId: scope.parent.cid,
                        page: 0,
                        size: 500
                    }).then(function(response){
                        if(!response || !response.content || !response.content.length){
                            return;
                        }
                        angular.forEach(response.content, function(event){
                            try {
                                event.eventInfo = typeof event.eventInfo === 'string' ? JSON.parse(event.eventInfo) : event.eventInfo;
                            } catch(e) {
                                event.eventInfo = {};
                            }
                            event.startTimeFormatted = moment(event.startTime).format("h:mma");
                            event.endTimeFormatted = moment(event.endTime).format("h:mma");
                            event.dateFormatted = event.startTimeFormatted + ' - ' + event.endTimeFormatted;
                            event.date = moment(event.startTime).format("ddd, MMM D, YYYY");
                            event.contributor = (scope.showUserFullName && event.externalUserEntity && event.externalUserEntity.user && event.externalUserEntity.user.firstName != null && event.externalUserEntity.user.lastName != null) ? event.externalUserEntity.user.firstName + ' ' + event.externalUserEntity.user.lastName : (event.externalUserEntity && event.externalUserEntity.user ? event.externalUserEntity.user.login : '');
                            event.isElapsed = moment().isAfter(event.startTime) && !moment().isBetween(event.startTime, event.endTime);
                            if(scope.eventsList.eventDates.indexOf(event.date) === -1){
                                scope.eventsList.eventDates.push(event.date);
                            }
                            var exists = scope.eventsList.events.filter(function(x){ return x.eventId == event.eventId; }).length > 0;
                            if(!exists){
                                scope.eventsList.events.push(event);
                                scope.eventsList.scheduledEvents.push(event);
                            }
                        });
                    }).catch(function(err){
                        $log.warn("Failed to fetch Google events", err);
                    });
                };

                scope.$watch('eventsList.events.length', function(val) {
                    scope.showLoadMoreEvents = scope.totalEvents > val;
                });

                scope.compare = function(a, b) {
                  var meetingTypeA = a.eventInfo.meetingType;
                  var meetingTypeB = b.eventInfo.meetingType;
                  var value = meetingTypeA - meetingTypeB;
                  console.log('calling compare!!: ', value);
                  return value;
                }

                scope.setCopyEventAlert = function(state){
                    scope.showCopyEventAlert = state;
                    if(state){
                        $timeout(function(){
                            scope.showCopyEventAlert = false;
                        }, 3000);
                    }
                };

                scope.loadMoreEvents = function(){
                    var lastEventIndex = scope.eventsList.scheduledEvents.length - 1,
                        lastEvent = scope.eventsList.scheduledEvents[lastEventIndex],
                        startDate = moment(lastEvent.startTime).add(1, "days").toDate();

                    scope.page++;
                    scope.getEvents(startDate, scope.eventsList.totalEventsFromDate)
                };

                scope.$watch('eventsList.date', function(){
                    if(scope.eventsList && scope.eventsList.date && scope.activeLink === 'scheduler'){
                        $('#listing-section').hide();
                        $('.emptyschedulesection').hide();
                        $('.empty-wrapper').show();
                        resetEventList();
                        scope.getEventCount(scope.eventsList.date);
                        SchedulerService.getTimezone.get(function(response){
                            scope.timezoneDefault = response.result;
                        });
                    }
                });

                scope.getEventCount = function(startDate){
                    var startDateTime = moment(startDate).hour(0).minute(0).second(0);
                    SchedulerService.getEventCount({
                        baseCollectionId: scope.parent.cid,
                        startDateTime: startDateTime.format("YYYY-MM-DD HH:mm:ss"),
                        timeZone: moment.tz.guess()
                    }).then(function(response){
                        if(response.count){
                            scope.eventsList.totalEventsFromDate = response.count;
                            scope.getEvents(startDate, response.count);
                            if (response.count > 0){
                              scope.hasEvents = true;
                            }
                        }
                        else if (!response.count){
                            scope.hasEvents = false;
                            $('.emptyschedulesection').show();
                            $('.empty-wrapper').hide();
                        }
                    }).catch(function(err) {
                        scope.error = err;
                        $log.error("An error occurred when trying to fetch event count");
                    });
                };

                var resetEventList = function(){
                    scope.eventsList.events = [];
                    scope.eventsList.eventDates = [];
                    scope.eventsList.totalEventsFromDate = 0;
                    scope.page = 0;
                    scope.eventsList.scheduledEvents = [];
                    scope.currentTotalCount = 0;
                };

                scope.loadEventForm = function(action, event){
                    scope.formType = action;
                    scope.editableEvent = event;
                };

                scope.startEvent = function(event){
                    var url = event.eventInfo.startUrl;
                    if (!url)
                        url = event.eventInfo.joinUrl;
                    $window.open(url, "_blank")
                };

                scope.createDeleteEventRequest = function(event){
                    scope.activeDeleteEventRequest = event;
                    $("#deleteConfirmation").modal('show');
                };

                scope.clearActiveDeleteEventRequest = function(){
                    scope.activeDeleteEventRequest = undefined;
                    $("#deleteConfirmation").modal('hide');
                };

                scope.deleteEvent = function(){
                    if(scope.activeDeleteEventRequest){
                        var event = scope.activeDeleteEventRequest;
                        var deleteResource = event.eventType === 'GOOGLE'
                            ? SchedulerService.GoogleDeleteEvent
                            : SchedulerService.deleteEvent;
                        deleteResource.erase({
                            meetingId: event.eventType === 'GOOGLE' ? event.eventId : event.eventInfo.meetingId
                        }, function (response) {
                            scope.resetScheduler();
                            scope.clearActiveDeleteEventRequest();
                        }, function(error) {
                            scope.resetScheduler();
                            scope.clearActiveDeleteEventRequest()
                        });
                    }
                };

                scope.joinEvent = function(event){
                    $window.open(event.eventInfo.joinUrl, "_blank")
                };

                scope.isSelectedDate = function(date){
                    return moment(date).isSame(scope.eventsList.date, 'day');
                };

                scope.isToday = function(date){
                    return moment().isSame(date, 'day');
                };

                scope.hasElapsed = function(event){
                    if (event.eventInfo.meetingType === 3) {
                        return false;
                    }
                    if(!event.isElapsed){
                        event.isElapsed = moment().isAfter(event.startTime) && !moment().isBetween(event.startTime, event.endTime);
                    }
                    return event.isElapsed;
                };

                scope.resetEventsListDate = function(){
                    scope.eventsList.date = new Date();
                };

                scope.showPreviousDay = function(){
                    $('#listing-section').hide();
                    $('.empty-wrapper').show();
                    var date = new Date();
                    SchedulerService.copyDatesWithoutTimeChange(date, scope.eventsList.date);
                    date.setDate(date.getDate() - 1);
                    loadEventsForDate(date);
                };

                scope.showNextDay = function(){
                    $('#listing-section').hide();
                    $('.empty-wrapper').show();
                    var date = new Date();
                    SchedulerService.copyDatesWithoutTimeChange(date, scope.eventsList.date);
                    date.setDate(date.getDate() + 1);
                    loadEventsForDate(date);
                };

                var loadEventsForDate = function(date){
                    $('#listing-section').hide();
                    $('.empty-wrapper').show();
                    scope.eventsList.eventDates = [];
                    scope.eventsList.events = [];
                    scope.eventsList.date = date;
                    scope.page = 0;
                    scope.eventsList.scheduledEvents = [];
                    scope.currentTotalCount = 0;
                };

                scope.$watch('activeLink', function(){
                    if(scope.activeLink){
                        if(scope.activeLink === 'scheduler'){
                            loadScheduler();
                        } else if(scope.schedulerLoaded) {
                            scope.resetScheduler();
                        }
                    }
                });

                // Make the event cancel modal accessible
                $("#cancelConfirmation").on('shown.bs.modal', function () {
                    modalFocus('#cancelEventbutton', '#eventBackbutton');
                });

                // Make the delete event modal accessible
                $("#deleteConfirmation").on('shown.bs.modal', function () {
                    modalFocus('#deleteEventbutton', '#cancelDeleteEventbutton');
                });

                var modalFocus = function(first, last){
                    var firstItem = $(first),
                        lastItem = $(last);

                    /*set focus on first item*/
                    firstItem.focus();

                    /*redirect last tab to first input*/
                    lastItem.on('keydown', function (e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            e.preventDefault();
                            firstItem.focus();
                        }
                    });

                    /*redirect first shift+tab to last input*/
                    firstItem.on('keydown', function (e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            e.preventDefault();
                            lastItem.focus();
                        }
                    });
                };

                scope.checkForEnterKey = function (event, action) {
                    if (event.keyCode === 13) {
                        if (action === "hideCancelEventModal") {
                            $("#cancelConfirmation").modal('hide');
                        }
                    }
                };

                scope.launchGoogle = function () {
                    SchedulerService.GoogleOAuth.get({standaloneInstall: false}, function(response){
                        $window.open(response.requestUrl, 'Authentication', 'width=972,height=660,modal=yes,alwaysRaised=yes');
                    });
                };
            }
        }
    }]);
